import React from 'react';
import SectionTitle from '../../components/SectionTitle/SectionTitle';
import './Services.scss';
import Service from '../../components/Service/Service';
import { useTranslation } from '../../i18n/useTranslation';
import iconOne from '../../assets/service/1.png';
import iconTwo from '../../assets/service/medicine.png';
import iconThree from '../../assets/service/3.png';
import iconFour from '../../assets/service/tooth.png';
import iconFive from '../../assets/service/rootcanaltreatment.png';

const Services = () => {
    const { t } = useTranslation();
    
    const servicesData = [
        {
            icon: iconOne,
            title: t('services.orthodontic.title'),
            description: t('services.orthodontic.description')
        },
        {
            icon: iconTwo,
            title: t('services.implants.title'),
            description: t('services.implants.description')
        },
        {
            icon: iconThree,
            title: t('services.whitening.title'),
            description: t('services.whitening.description')
        },
        {
            icon: iconFour,
            title: t('services.gumCleaning.title'),
            description: t('services.gumCleaning.description')
        },
        {
            icon: iconFive,
            title: t('services.rootCanal.title'),
            description: t('services.rootCanal.description')
        }
    ];
    
    return (
        <section className='service-section pt-100 pb-70' data-aos="fade-up" data-aos-duration="2000">
            <div className="container">
                <div className="row">
                    <div className="col-lg-6 col-sm-6">
                        <SectionTitle title={t('services.title')} subTitle={t('services.subTitle')}/>
                    </div>
                </div>

                <div className="row">
                    {
                        servicesData.map((singleService, index) => (
                            <Service key={index} serviceList={singleService} accredited={false}/>
                        ))
                    }
                </div>
            </div>
        </section>
    );
};

export default Services;
